export default "__VITE_ASSET__BOHTsPS9__"